import React from "react";
import ReactDOM from "react-dom/client";
import "@/index.css";
import App from "@/App";

const root = ReactDOM.createRoot(document.getElementById("root"));
root.render(
  <React.StrictMode>
    <App />
  </React.StrictMode>,
);

// Register service worker
if ('serviceWorker' in navigator) {
  // Un SW contrôlait-il DÉJÀ la page au chargement ? Si oui, une prise de
  // contrôle par un nouveau SW = une mise à jour → on recharge pour servir le
  // nouveau build. Si non (tout premier install), le controllerchange déclenché
  // par clients.claim ne doit PAS provoquer de rechargement.
  const hadController = !!navigator.serviceWorker.controller;
  let refreshing = false;
  navigator.serviceWorker.addEventListener('controllerchange', () => {
    if (refreshing || !hadController) return;
    refreshing = true;
    window.location.reload();
  });

  window.addEventListener('load', () => {
    navigator.serviceWorker.register('/service-worker.js')
      .then((reg) => {
        console.log('SW registered:', reg.scope);
        // Vérifie une mise à jour à chaque chargement (le navigateur re-fetch
        // service-worker.js et compare octet à octet ; le CACHE_NAME bumpé
        // suffit à le voir comme différent).
        reg.update();
      })
      .catch((err) => {
        console.log('SW registration failed:', err);
      });
  });
}
